import type {SchedulerTemplateForm} from 'src/types/scheduler/template-form';


let templateFormAnalyticsState: SchedulerTemplateForm | null = null;

export function getTemplateFormAnalyticsState(): SchedulerTemplateForm | null {
  return templateFormAnalyticsState;
}

export function setTemplateFormAnalyticsState(
  updatedTemplateForm: SchedulerTemplateForm | null,
): void {
  templateFormAnalyticsState = updatedTemplateForm;
}
